export default __webpack_public_path__ + "static/media/arrow_dropdown_filter_black.69691774.svg";